import { GET_ALERTS } from '../../types'

const initialState = {
  alerts: {}
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ALERTS: return {
      ...state,
      alerts: action.payload
    }
    default: return { ...state }
  }
}
